import cover1     from '../assets/covers/album-1.png';
import cover1x2   from '../assets/covers/album-1@2x.png';
import cover1w    from '../assets/covers/album-1.webp';
import cover1wx2  from '../assets/covers/album-1@2x.webp';

import cover2     from '../assets/covers/album-2.png';
import cover2x2   from '../assets/covers/album-2@2x.png';
import cover2w    from '../assets/covers/album-2.webp';
import cover2wx2  from '../assets/covers/album-2@2x.webp';

import cover3     from '../assets/covers/album-3.png';
import cover3x2   from '../assets/covers/album-3@2x.png';
import cover3w    from '../assets/covers/album-3.webp';
import cover3wx2  from '../assets/covers/album-3@2x.webp';

export const albums = [
  {
    id: 'armageddon',
    title: 'ΑΡΜΑΓΕΔΔΩΝ',
    artist: 'Pavlos ft. Elsa',
    year: 2024,
    genre: 'Pop Dance',
    accent: '#f5b849',
    cover: {
      png:  { x1: cover1,  x2: cover1x2 },
      webp: { x1: cover1w, x2: cover1wx2 },
    },
    track: {
      title: 'ΑΡΜΑΓΕΔΔΩΝ',
      src: process.env.PUBLIC_URL + '/audio/album-1.mp3',
    },
  },
  {
    id: 'armageddon-epistrofi',
    title: 'ΑΡΜΑΓΕΔΔΩΝ 2: Η ΕΠΙΣΤΡΟΦΗ',
    artist: 'Pavlos ft. Elsa',
    year: 2025,
    genre: 'Pop Dance',
    accent: '#ff5a1f',
    cover: {
      png:  { x1: cover2,  x2: cover2x2 },
      webp: { x1: cover2w, x2: cover2wx2 },
    },
    track: {
      title: 'ΑΡΜΑΓΕΔΔΩΝ 2: Η ΕΠΙΣΤΡΟΦΗ',
      src: process.env.PUBLIC_URL + '/audio/album-2.mp3',
    },
  },
  {
    id: 'armageddon-annihilation',
    title: 'ΑΡΜΑΓΕΔΔΩΝ 3: ΑΦΑΝΙΣΜΟΣ',
    artist: 'Pavlos ft. Elsa',
    year: 2026,
    genre: 'Pop Dance',
    accent: '#c8321a',
    cover: {
      png:  { x1: cover3,  x2: cover3x2 },
      webp: { x1: cover3w, x2: cover3wx2 },
    },
    track: {
      title: 'ΑΡΜΑΓΕΔΔΩΝ 3: ΑΦΑΝΙΣΜΟΣ',
      src: process.env.PUBLIC_URL + '/audio/album-3.mp3',
    },
  },
];

export const findAlbum = (id) => albums.find((a) => a.id === id);
export const albumIndex = (id) => albums.findIndex((a) => a.id === id);
